import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { Add, Edit } from '@mui/icons-material';
import { getAllProductBundle, getBundleListxlsx } from '../modules/productdata';
import { ActionAllowed } from '../rbac/rbacutil';
import { rbacactions } from '../rbac/rbacrules';
import { useTranslation } from 'react-i18next';
import Footer from '../main/footer';
import { formatCurrency } from '../common/common';
import Spinner from '../common/spinner';
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import FooterPadding from '../main/footerpadding';

const delay = async (ms) => {
    await new Promise((r) => setTimeout(r, ms));
};

export default function ProductBundleList(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [reff] = React.useState(React.createRef());
    const [blobUrl, setBlobUrl] = React.useState('');
    const [loadingXlsx, setLoadingXlsx] = React.useState(false);

    const productBundleList = useSelector((state) => state.productdata.productBundles);
    const userProfile = useSelector((state) => state.authentication.userProfile);

    const loadBundleList = async (e) => {
        if (blobUrl) {
            e.stopPropagation();
            await delay(100);
            setBlobUrl('');
            setLoadingXlsx(false);
            return;
        }
        setLoadingXlsx(true);
        const xlsx = await getBundleListxlsx();

        const buff = Buffer.from(xlsx, 'base64');
        const blob = new Blob([buff.buffer], {
            type: 'application/vnd.openxmlformats',
        });
        const url = URL.createObjectURL(blob);
        setBlobUrl(url);

        setTimeout(() => {
            reff.current.click();
        }, 10);
    };

    useEffect(() => {
        if (productBundleList == null) {
            getAllProductBundle()(dispatch);
        }
    }, [productBundleList, dispatch]);

    const calculateTotalPrice = (bundle) => {
        let sum = 0;
        if (bundle.products.length > 0) {
            for (let bundleProduct of bundle.products) {
                sum += bundleProduct.product.priceWithoutVat * bundleProduct.productCount;
            }
        }
        return sum;
    };

    const editBundle = (bundleId) => {
        history.push(`/product/bundleedit/${bundleId}`);
    };

    return (
        <Grid container>
            {productBundleList !== null && productBundleList.length === 0 && (
                <Grid item xs={12} sx={{ p: '0.5em' }}>
                    {t('product.noPrpductBundles')}
                </Grid>
            )}
            <Grid container sx={{ p: '0.5em' }}>
                <Grid item xs={5}>
                    <strong>{t('general.name')}</strong>
                </Grid>
                <Grid item xs={2}>
                    <strong>{t('product.code')}</strong>
                </Grid>
                <Grid item xs={1}>
                    <strong>{t('general.price')}</strong>
                </Grid>
                <Grid item xs={2}>
                    <strong>{t('general.edited')}</strong>
                </Grid>
                <Grid item xs={2}></Grid>
            </Grid>
            {productBundleList === null && <Spinner />}
            {productBundleList !== null && productBundleList.length > 0 && (
                <React.Fragment>
                    {productBundleList.map((b) => (
                        <Grid container key={b.id} sx={{ p: '0.5em' }}>
                            <Grid item xs={5}>
                                {b.name}
                            </Grid>
                            <Grid item xs={2}>
                                {b.code}
                            </Grid>
                            <Grid item xs={1}>
                                {formatCurrency(calculateTotalPrice(b))}
                            </Grid>
                            <Grid item xs={2}>
                                <span>{moment(b.update).format('D.M.YYYY HH:mm')}</span>
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    variant="contained"
                                    name="btn-edit-bundle"
                                    color="primary"
                                    onClick={() => editBundle(b.id)}
                                    startIcon={<Edit />}>
                                    {t('buttons.edit')}
                                </Button>
                            </Grid>
                        </Grid>
                    ))}
                </React.Fragment>
            )}
            <Footer>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        name="btn-new-bundle"
                        disabled={!ActionAllowed(rbacactions.CreateNewProduct, userProfile)}
                        onClick={() => history.push('/product/bundleedit/new')}
                        startIcon={<Add />}>
                        {t('general.bundle')}
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        ref={reff}
                        variant="contained"
                        color="primary"
                        disabled={loadingXlsx || !ActionAllowed(rbacactions.LoadProductList, userProfile)}
                        name="btn-load-product-xsls"
                        onClick={loadBundleList}
                        href={blobUrl.length > 0 ? blobUrl : null}
                        download={blobUrl.length > 0 ? `Tuotesarjat_${moment().format()}.xlsx` : null}
                        startIcon={
                            loadingXlsx ? <CircularProgress color={'secondary'} size={'1rem'} /> : <CloudDownloadIcon />
                        }>
                        {t('location.buttons.download')}
                    </Button>
                </Grid>
            </Footer>
            <FooterPadding />
        </Grid>
    );
}
